/**
 * @Description 客群学历分布
 */

import { FC } from 'react';
import styles from './index.module.less';
import cs from 'classnames';
import V2PieChart from '@/common/components/Charts/V2PieChart';
import { isArray } from '@lhb/func';

const EducationRatio: FC<any> = ({
  detail,
}) => {
  return (
    <div className={cs(styles.chartWrapper, styles.pieChart, 'pd-16', styles.customerHeight)}>
      <div className='fs-14 c-222 bold'>客群学历分布</div>
      { isArray(detail) && detail.length
        ? <V2PieChart
          title=''
          type='circle'
          resizable
          seriesData={[{
            data: detail,
            unit: '%',
            animation: false,
            radius: ['46%', '58%'],
            center: ['28%', '52%']
          }]}
          height={260}
        /> : <></>}
    </div>
  );
};

export default EducationRatio;
